import React, { Component } from 'react'

class List extends Component {
  addressInfo(championship) {
    if (championship.city && championship.state) {
      return(
        <React.Fragment>
          <span className='icon'><i className='fa fa-map-marker'></i></span>
          <span className='street'>{`${championship.city} - ${championship.state}`}</span>
        </React.Fragment>
      )
    }
  }
  render() {
    const {results} = this.props;
    if (results.length == 0) return null;

    let resultsList = results.map((championship, index) => {
      let eventPath = championship.publishedPage ? `/events/${championship.slug}` : '#'
      return (
        <div className="col-sm-12 col-md-6 col-lg-4 col-xxl-3 my-2" key={index}>
          <div className="event">
            <a href={eventPath}>
              <div
                className="row logo height-fix"
                style={{ backgroundImage: `url(${championship.urlLogo})` }}
              ></div>
              <div className="row championship-info">
                <div
                  className="col-4 col-md-5 date"
                  style={{
                    backgroundColor: `${championship.logoBaseColor}`,
                    color: `${championship.fontColor}`
                  }}
                >
                  <span>{`${championship.eventIntervalDays}`}</span>
                </div>
                <div className="col-8 col-md-7 location">
                  {this.addressInfo(championship)}
                </div>
              </div>
            </a>
          </div>
        </div>
      );
    });

    return ( resultsList )
  }
}
export default List;
